import { object, date, string } from "yup";

const newPlanSchema = (localization) => object({
  start_date: date().required(localization.timeframe.fields.start_date.errors.required),
  target_date: date()
    .required(localization.timeframe.fields.target_date.errors.required)
    .test(
      "is-after-start-date",
      localization.timeframe.fields.target_date.errors.is_after_start_date,
      (target_date, context) => {
        const { start_date } = context.parent;
        return target_date && start_date && target_date > start_date;
      }
    ),
  option: string()
    .required(localization.options.errors.required)
    .oneOf(["blank", "template", "generate"], localization.options.errors.invalid)
}).required();

export default newPlanSchema;